export default __webpack_public_path__ + "static/media/status.61b1f78d.png";